// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3SDK9","label":"LabeledBox_label__ZxsHq"};